import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { fcheck_null_undefine_replace_empty } from "../../Utility/Utilitys";
import { onGetHRMonthly_Appraisal } from "./HRSalaryAppraisalAction";

const HRSalaryAppraisal = () => {
  // Retrieve branch data from Redux store
  const branchData = useSelector((state) => state.SliceDB.value.DbData.Branch);

  // Dynamic year selection
  const currentYear = new Date().getFullYear();
  const previousYear = currentYear - 1;

  // Local state for selected branch, year, data, and loading indicator
  const [selectedBranch, setSelectedBranch] = useState(branchData[0]?.Uid);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [data, setData] = useState([]);

  // Handle branch select change
  const handleBranchChange = (event) => {
    setSelectedBranch(event.target.value);
  };

  // Handle year select change
  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  // Load data from the API based on selected branch and year
  const handleLoadData = async () => {
    // Simulate API call

    const obj = {
      P_Branch: selectedBranch,
      P_Year: selectedYear,
    };

    const response = await onGetHRMonthly_Appraisal(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (response?.status === 200 && response?.data?.ResultSet) {
      console.log("handleLoad", response?.data?.ResultSet);
      setData(response?.data?.ResultSet);
    } else {
      setData([]);
    }
  };

  // Sample columns for the DataGrid
  const columns = [
    { field: "EMPID", headerName: "Employee ID", width: 95 },
    { field: "EMPName", headerName: "Employee Name", width: 180 },
    { field: "JobTitleName", headerName: "Job Title", width: 150 },
    { field: "Department", headerName: "Department", width: 130 },
    { field: "MainBranch", headerName: "Branch", width: 150 },
    { field: "CurrentBranch", headerName: "Current Branch", width: 150 },
    { field: "SupervisorName", headerName: "Supervisor", width: 150 },
    { field: "EmployeeDuration", headerName: "Service Duration", width: 150 },
    { field: "lastIncrement", headerName: "Last Increment", width: 110 },
    { field: "CurrentSalary", headerName: "Current Salary", width: 140 },
    { field: "AchivedPerc", headerName: "Achieved.%", width: 95 },
    { field: "Achieved", headerName: "Achievement Appraisal", width: 180 },
    { field: "FinalAppraisal", headerName: "Final Appraisal", width: 120 },
    { field: "NewSalary", headerName: "New Salary", width: 100 },
  ];
  useEffect(() => {
    handleLoadData();
  }, []);
  return (
    <div className="div-container">
    <Box sx={{ p: 1 }}>
      {/* Filter Section */}
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 2 }}>
        {/* Branch Select */}
        <FormControl sx={{ minWidth: 200 }} size="small">
          <InputLabel id="branch-select-label">Branch</InputLabel>
          <Select
            labelId="branch-select-label"
            id="branch-select"
            value={selectedBranch}
            label="Branch"
            onChange={handleBranchChange}
          >
            {branchData &&
              branchData?.map((branchItem) => (
                <MenuItem key={branchItem.Uid} value={branchItem.Uid}>
                  {branchItem.Name1}
                </MenuItem>
              ))}
          </Select>
        </FormControl>

        {/* Year Select */}
        <FormControl sx={{ minWidth: 200 }} size="small">
          <InputLabel id="year-select-label">Year</InputLabel>
          <Select
            labelId="year-select-label"
            id="year-select"
            value={selectedYear}
            label="Year"
            onChange={handleYearChange}
          >
            <MenuItem value={previousYear}>{previousYear}</MenuItem>
            <MenuItem value={currentYear}>{currentYear}</MenuItem>
          </Select>
        </FormControl>

        {/* Load Data Button */}
        <Button variant="contained" onClick={handleLoadData}>
          Load
        </Button>
      </Box>

      {/* DataGrid Section */}
      <Box
        sx={{
          height: { xs: "62vh", sm: "70vh", md: "74vh", lg: "76vh" },
          width: "100%",
        }}
      >
        <DataGrid
          rows={data}
          columns={columns}
          getRowId={(row) => row.EMPID}
          rowHeight={30}
          headerHeight={40}
          hideFooter={data.length < 100}
          components={{
            Toolbar: GridToolbar,
          }}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          sx={{
            border: 1,
            borderColor: "primary.light",
              '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#0d73bb',
                    color: 'white'
                  },
          }}
        />
      </Box>
    </Box>
    </div>
  );
};

export default HRSalaryAppraisal;
